import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
export default ProtoBaseModel.extend({
  itemName: attr(String),
  itemToken: attr(String),
  itemVariationName: attr(String),
  itemVariationToken: attr(String),
  sku: attr(String),
  gtin: attr(String),
  price: attr(MoneyProto),
  measurementUnitAbbr: attr(String),
  count: attr(Number)
});